export default "__VITE_ASSET__6714d6b3__"